<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  created () {
    // document.oncontextmenu = function () { return false; };
    // document.onkeydown = document.onkeyup = document.onkeypress = function(event) {
    //   var e = event || window.event || arguments.callee.caller.arguments[0];
    //   if (e && e.keyCode == 123) {
    //     e.returnValue = false;
    //     return (false);
    //   }
    // }
  }
}
</script>

<style>

</style>
